import {
  CaracteristicasState,
  MetadataState,
  caracteristicasInitialState,
  metadataInitialState,
  CaracteristicasAction,
} from 'store/modules/debenture/caracteristicas';
import {
  CriteriosRemuneracaoAction,
  criteriosRemuneracaoInitialState,
} from 'store/modules/debenture/criteriosRemuneracao';
import {
  EventosAction,
  eventosInitialState,
} from 'store/modules/debenture/eventos';
import { UploadDocumentosAction, uploadDocumentosInitialState } from 'store/modules/debenture/uploadDocumentos';
import {
  EmissorAction,
  State as EmissorState,
  initialState as emissorInitialState,
} from 'store/modules/debenture/emissor';
import { CriteriosRemuneracao, Amortizacao, UploadDocumentos, TipoRegistroInstrumentoFinanceiro, EventosFinanceiros as EventosState } from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import { Attachment } from 'components/uploadDocs';
import { AditamentoAction } from './aditamento';

interface State {
  caracteristicas: CaracteristicasState;
  metadata: MetadataState;
  criteriosRemuneracao: CriteriosRemuneracao;
  emissor: EmissorState;
  eventos: EventosState;
  uploadDocumentos: UploadDocumentos;
  highlightErrors: boolean;
  typeOfRegister: TipoRegistroInstrumentoFinanceiro;
  uploadDocumentoAditamento: Attachment[];
  dataAditamento: string | undefined;
}

export const typeOfRegister = (payload: TipoRegistroInstrumentoFinanceiro) => {
  return typedAction('debenture/TYPE_OF_REGISTER', payload);
};

export const highlightErrors = (payload: boolean) => {
  return typedAction('debenture/HIGHLIGHT_ERRORS', payload);
};

export function debentureReducer(
  state: State = {
    caracteristicas: caracteristicasInitialState,
    metadata: metadataInitialState,
    criteriosRemuneracao: criteriosRemuneracaoInitialState,
    emissor: emissorInitialState,
    eventos: eventosInitialState,
    uploadDocumentos: uploadDocumentosInitialState,
    highlightErrors: false,
    typeOfRegister: TipoRegistroInstrumentoFinanceiro.Cadastro,
    uploadDocumentoAditamento: [],
    dataAditamento: undefined,
  },
  action:
    | CaracteristicasAction
    | CriteriosRemuneracaoAction
    | EmissorAction
    | EventosAction
    | UploadDocumentosAction
    | ReturnType<typeof highlightErrors>
    | ReturnType<typeof typeOfRegister>
    | AditamentoAction
): State {
  switch (action.type) {
    //Características
    case 'debenture/metadata/UPDATEFIELD':
      return { ...state, metadata: { ...state.metadata, [action.payload.name]: action.payload.value } };
    case 'debenture/caracteristicas/UPDATEFIELD':
      return { ...state, caracteristicas: { ...state.caracteristicas, [action.payload.name]: action.payload.value } };
    case 'debenture/caracteristicas/RESET':
      return { ...state, caracteristicas: { ...caracteristicasInitialState } };
    case 'debenture/caracteristicas/UPDATE':
      return { ...state, caracteristicas: action.payload };
    //Critério de Remuneração
    case 'debenture/criteriosRemuneracao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: { ...state.criteriosRemuneracao, [action.payload.name]: action.payload.value },
      };
    case 'debenture/criteriosRemuneracao/remuneracao/UPDATE':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          remuneracao: action.payload,
        },
      };
    case 'debenture/criteriosRemuneracao/remuneracao/UPDATEFIELD':
      return {
        ...state,
        criteriosRemuneracao: {
          ...state.criteriosRemuneracao,
          remuneracao: { ...state.criteriosRemuneracao.remuneracao, [action.payload.name]: action.payload.value },
        },
      };
    case 'debenture/criteriosRemuneracao/RESET':
      return { ...state, criteriosRemuneracao: criteriosRemuneracaoInitialState };
    case 'debenture/criteriosRemuneracao/UPDATE':
      return { ...state, criteriosRemuneracao: action.payload };
    //Custo de Emissão
    case 'debenture/criteriosRemuneracao/custoEmissao/UPDATEFIELD':
      return { 
        ...state, 
        criteriosRemuneracao: { 
          ...state.criteriosRemuneracao, 
          custoEmissao: {
            ...state.criteriosRemuneracao.custoEmissao, [action.payload.name]: action.payload.value },
        }
      };
    //Emissor
    case 'debenture/emissor/UPDATE_ID':
      return { ...state, emissor: { ...state.emissor, id: action.payload } };
    case 'debenture/emissor/UPDATE_CODIGO':
      return { ...state, emissor: { ...state.emissor, codigoExterno: action.payload } };
    case 'debenture/emissor/RESET':
      return { ...state, emissor: { ...emissorInitialState } };
    //Eventos Financeiros
    case 'debenture/eventos/UPDATE':
      return { ...state, eventos: action.payload };
    case 'debenture/eventos/UPDATEFIELD':
      return { ...state, eventos: { ...state.eventos, [action.payload.name]: action.payload.value } };
    case 'debenture/eventos/RESET':
      return { ...state, eventos: eventosInitialState };
    case 'debenture/eventos/datasPagamentoJuros/UPDATE':
      return {
        ...state,
        eventos: { ...state.eventos, datasPagamentoJuros: action.payload.map((dateViewModel) => dateViewModel.date) },
      };
    case 'debenture/eventos/datasIncorporacaoJuros/UPDATE':
      return {
        ...state,
        eventos: {
          ...state.eventos,
          datasIncorporacaoJuros: action.payload.map((dateViewModel) => dateViewModel.date),
        },
      };
    case 'debenture/eventos/amortizacoes/UPDATE':
      const amortizacoes: Amortizacao[] = action.payload.map((amortizacao) => ({
        percentualAmortizacao: amortizacao.percentualAmortizacao,
        dataAmortizacao: amortizacao.dataAmortizacao,
      }));
      return {
        ...state,
        eventos: { ...state.eventos, amortizacoes },
      };
    //Documentos
    case 'debenture/uploadDocumentos/UPDATE':
      return {
        ...state,
        uploadDocumentos: { ...state.uploadDocumentos, documents: action.payload },
      };
    case 'debenture/uploadDocumentos/documentsToDelete/UPDATE':
      return {
        ...state,
        uploadDocumentos: { ...state.uploadDocumentos, documentsToDelete: action.payload },
      };
    case 'debenture/uploadDocumentos/RESET':
      return { ...state, uploadDocumentos: uploadDocumentosInitialState };
    //Erros
    case 'debenture/HIGHLIGHT_ERRORS':
      return { ...state, highlightErrors: action.payload };
    default:
      return state;
    //Type of Register
    case 'debenture/TYPE_OF_REGISTER':
      return { ...state, typeOfRegister: action.payload };
    //Aditamento
    case 'debenture/UPLOAD_DOCUMENTO_ADITAMENTO':
      return { ...state, uploadDocumentoAditamento: action.payload };
    case 'debenture/UPLOAD_DOCUMENTO_ADITAMENTO/RESET':
      return { ...state, uploadDocumentoAditamento: [] };
    case 'debenture/DATA_ADITAMENTO':
      return { ...state, dataAditamento: action.payload };
    case 'debenture/DATA_ADITAMENTO/RESET':
      return { ...state, dataAditamento: undefined };
  }
}

export default debentureReducer;
